<template>
  <div>
    <h4>
      Please register your details to create a user account. Your user account
      enables you to submit an abstract, register for the conference, book a
      hotel and more.
    </h4>
    <br />

    <form>
      <div class="row">
        <div class="col-md-6 form-group">
          <label>Title (Degree - Dr., Professor, etc.) <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="title"
            v-model="data.title"
            v-validate="'required'"
            data-vv-as="Title"
          />
          <div class="text-danger">{{ veeErrors.first("title") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>First Name <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="first_name"
            v-model="data.first_name"
            v-validate="'required'"
            data-vv-as="First Name"
          />
          <div class="text-danger">{{ veeErrors.first("first_name") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Last Name <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="last_name"
            v-model="data.last_name"
            v-validate="'required'"
            data-vv-as="Last Name"
          />
          <div class="text-danger">{{ veeErrors.first("last_name") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Post-Nominal Letters (PH.D., M.SC. ETC.)</label>
          <input
            type="text"
            class=""
            name="post_nominal_letter"
            v-model="data.post_nominal_letter"
          />
          <div class="text-danger">
            {{ veeErrors.first("post_nominal_letter") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Email <sup>*</sup></label>
          <input
            type="email"
            class=""
            name="email"
            v-model="data.email"
            v-validate="'required|email_exists'"
            data-vv-as="Email"
          />
          <div class="text-danger">{{ veeErrors.first("email") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Phone <sup>*</sup></label>
          <small
            >Enter the number in full international format starting with the + (
            e.g.: +62 xxx)</small
          >
          <input
            type="text"
            class=""
            name="phone"
            v-model="data.phone"
            v-validate="'required'"
            data-vv-as="Phone"
          />
          <div class="text-danger">{{ veeErrors.first("phone") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Organisation <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="organisation"
            v-model="data.organisation"
            v-validate="'required'"
            data-vv-as="Organisation"
          />
          <div class="text-danger">{{ veeErrors.first("organisation") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Department</label>
          <input
            type="text"
            class=""
            name="department"
            v-model="data.department"
            data-vv-as="department"
          />
          <div class="text-danger">{{ veeErrors.first("department") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Street, Number <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="street"
            v-model="data.street"
            v-validate="'required'"
            data-vv-as="Street, Number"
          />
          <div class="text-danger">{{ veeErrors.first("street") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Town/City <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="city"
            v-model="data.city"
            v-validate="'required'"
            data-vv-as="Town/City"
          />
          <div class="text-danger">{{ veeErrors.first("city") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Post/Zip Code <sup>*</sup></label>
          <input
            type="text"
            class=""
            name="zip_code"
            v-model="data.zip_code"
            v-validate="'required'"
            data-vv-as="Post/Zip Code"
          />
          <div class="text-danger">{{ veeErrors.first("zip_code") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Gender <sup>*</sup></label>
          <multiselect
            v-model="selectedGender"
            placeholder="Please select an option"
            label="name"
            track-by="name"
            name="gender"
            :close-on-select="true"
            :clear-on-select="true"
            :options="genders"
            :multiple="false"
            :allow-empty="false"
            :preselect-first="false"
            v-validate="'required'"
          ></multiselect>
          <div class="text-danger">{{ veeErrors.first("gender") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 form-group">
          <label>Country <sup>*</sup></label>
          <multiselect
            v-model="selectedCountry"
            placeholder="Please select an option"
            label="name"
            track-by="name"
            name="country"
            :close-on-select="true"
            :clear-on-select="true"
            :options="countries"
            :multiple="false"
            :allow-empty="false"
            :preselect-first="false"
            v-validate="'required'"
          ></multiselect>
          <div class="text-danger">{{ veeErrors.first("country") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Company Identification Number</label>
          <input
            type="text"
            class=""
            name="company_identify_number"
            v-model="data.company_identify_number"
            data-vv-as="Company Identification Number"
          />
          <div class="text-danger">
            {{ veeErrors.first("company_identify_number") }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Vat Number</label>
          <input
            type="text"
            class=""
            name="vat_number"
            v-model="data.vat_number"
            data-vv-as="Vat Number"
          />
          <div class="text-danger">{{ veeErrors.first("vat_number") }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 form-group">
          <input
            type="checkbox"
            name="showBillingAddress"
            v-model="showBillingAddress"
          />
          <label>Different billing address (for invoicing)</label>
        </div>
      </div>

      <div class="row" v-if="showBillingAddress">
        <div class="col-md-6 form-group">
          <label>Organisation</label>
          <input
            type="text"
            class=""
            name="billing_organisation"
            v-model="billing.organisation"
            v-validate="'required'"
            data-vv-as="Organisation"
          />
          <div class="text-danger">
            {{ veeErrors.first("billing_organisation") }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Email</label>
          <input
            type="email"
            class=""
            name="billing_email"
            v-model="billing.email"
            v-validate="'required'"
            data-vv-as="email"
          />
          <div class="text-danger">
            {{ veeErrors.first("billing_email") }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Street, Number</label>
          <input
            type="text"
            class=""
            name="billing_street"
            v-model="billing.street"
            v-validate="'required'"
            data-vv-as="Street, Number"
          />
          <div class="text-danger">{{ veeErrors.first("billing_street") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Town/City</label>
          <input
            type="text"
            class=""
            name="billing_city"
            v-model="billing.city"
            v-validate="'required'"
            data-vv-as="Town/City"
          />
          <div class="text-danger">{{ veeErrors.first("billing_city") }}</div>
        </div>
        <div class="col-md-6 form-group">
          <label>Post/Zip Code</label>
          <input
            type="text"
            class=""
            name="billing_zip_code"
            v-model="billing.zip_code"
            v-validate="'required'"
            data-vv-as="Post/Zip Code"
          />
          <div class="text-danger">
            {{ veeErrors.first("billing_zip_code") }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Country</label>
          <multiselect
            v-model="selectedCountryBilling"
            placeholder="Please select an option"
            label="name"
            track-by="name"
            name="billing_country"
            :close-on-select="true"
            :clear-on-select="true"
            :options="countries"
            :multiple="false"
            :allow-empty="false"
            :preselect-first="false"
            v-validate="'required'"
          ></multiselect>
          <div class="text-danger">
            {{ veeErrors.first("billing_country") }}
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-12 form-group">
          <label>Participant <sup>*</sup></label>
          <multiselect
            v-model="selectedPeserta"
            placeholder="Please select an option"
            label="name"
            track-by="name"
            name="peserta"
            :close-on-select="true"
            :clear-on-select="true"
            :options="peserta"
            :multiple="false"
            :allow-empty="false"
            :preselect-first="false"
            @input="onChangePeserta"
            v-validate="'required'"
            data-vv-as="participant"
          >
          </multiselect>
          <div class="text-danger">{{ veeErrors.first("peserta") }}</div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-12 form-group mt-5">
          <button class="btn btn-success" @click.prevent="submit">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["dataprop"],
  filters: {
    formatSize: function (value) {
      if (!value) return "";
      let valKB = 0.000001 * value;
      return `${valKB.toFixed(2)} MB`;
    },
  },
  data() {
    return {
      url: "",
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      type: "",
      data: {},
      billing: {
        organisation: "",
        email: "",
        street: "",
        city: "",
        zip_code: "",
        country_id: "",
      },
      selectedCountry: null,
      selectedCountryBilling: null,
      countries: [],
      selectedGender: null,
      genders: [
        { id: 1, uuid: "m", name: "Male" },
        { id: 2, uuid: "f", name: "Female" },
      ],
      selectedEvent: null,
      events: [],
      files: [],
      showBillingAddress: false,
      selectedPeserta: null,
      peserta: [
        { id: 0, name: "Indonesian Participant" },
        { id: 1, name: "Non-Indonesian Participant" },
      ],
      selectedAccomodation: null,
      accomodations: [],
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      this.getCountry();
      //   this.getEvent();
      this.checkEmail();
    },
    async getCountry() {
      let url = "/countries/all";
      this.countries = await axios.post(url, {}).then((response) => {
        return response.data;
      });
    },
    async getEvent() {
      let url = "/event/all";
      this.events = await axios.post(url, {}).then((response) => {
        return response.data;
      });
    },
    checkEmail() {
      this.$validator.extend("email_exists", {
        getMessage: (field) => `This email has been registered`,
        validate: (value) => {
          return axios
            .get("checkemail/" + value)
            .then((response) => {
              return {
                valid: response.data.valid,
              };
            })
            .catch((error) => {
              return { error: response.error.val };
            });
        },
      });
    },
    onChangePeserta() {
      this.accomodations = [];

      if (this.selectedPeserta.id === 1) {
        this.accomodations = [
          {
            id: 1,
            type: "Early Bird",
            name: "Menginap Fullboard",
            price: 4950000,
          },
          {
            id: 2,
            type: "Early Bird",
            name: "Menginap Fullday",
            price: 4750000,
          },
          {
            id: 3,
            type: "Early Bird",
            name: "Tidak Menginap Fullboard",
            price: 4200000,
          },
          {
            id: 4,
            type: "Early Bird",
            name: "Tidak Menginap Fullday",
            price: 3750000,
          },
        ];
      } else if (this.selectedPeserta.id === 2) {
        this.accomodations = [
          { id: 1, type: "Early Bird", name: "Fullboard", price: 12650000 },
          { id: 2, type: "Late Bird", name: "Fullboard", price: 14100000 },
        ];
      }
    },
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.data.country = this.selectedCountry.name;
          this.data.gender = this.selectedGender.name;

          if (this.selectedCountry.name.toLowerCase() === "indonesia") {
            this.data.is_indonesian = 1;
          } else {
            this.data.is_indonesian = 0;
          }

          if (this.showBillingAddress) {
            this.billing.country_id = this.selectedCountryBilling.id;
            this.billing.country = this.selectedCountryBilling.name;
            this.data.billing_address = this.billing;
          }

          let msg = "Confirm!",
            txt = "Submit now?",
            action = "axiosForm";
          this.confirmAlert(msg, txt, action);
        }else{
            this.$swal('Attention!', 'Please complete all field required', 'warning')
        }
      });
    },
    confirmAlert(msg, txt, action) {
      this.$swal({
        title: msg,
        text: txt,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.isConfirmed) {
          switch (action) {
            case "axiosForm":
              this.$swal({
                title: "Please wait!",
                html: "loading...",
                allowOutsideClick: false,
                onBeforeOpen: () => {
                  Swal.showLoading();
                },
              });

              this.axiosForm(this.data);
              break;
          }
        }
      });
    },
    axiosForm(data) {
      let url = `/register`;
      axios
        .post(url, data)
        .then((response) => {
          let msg = response.data.message;
          if (msg == "success") {
            this.$swal({
              title: "Success",
              text: "Register success.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });

            let dataEmit = {
              action: "notif",
              data,
            };
            this.$emit("dataprop", dataEmit);
          } else {
            this.$swal("Error!", "Something wrong!", "error");
          }
        })
        .catch((err) => {
          this.$swal("Error!", "Something wrong!", "error");
        });
    },
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    labelEvent({ name, price }) {
      price = this.formatRupiah(price);
      return `${name} — ${price}`;
    },
    labelAccomodation({ name, price }) {
      price = this.formatRupiah(price);
      return `${name} — ${price}`;
    },
    getImage(link) {
      return `${link}`;
    },
    validateFileSize(size) {
      if (0.000001 * size > 1.024) {
        return false;
      }
      return true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile) {
        let check = this.validateFileSize(newFile.size);
        if (!check) {
          this.$refs.upload.remove(newFile);
          this.$swal("Error!", "Max file upload 1 MB.", "error");
        } else {
          this.$refs.upload.active = true;
        }
      }
    },
    async uploadFile(file, component) {
      let result = await component.uploadHtml5(file);
      this.files[0].name = result.response.filename;
      this.data.bukti_bayar = result.response.filename;
      return result;
    },
    formData(obj) {
      var formData = new FormData();
      for (var key in obj) {
        formData.append(key, obj[key]);
      }
      return formData;
    },
    alertError(msg) {
      this.$swal({
        icon: "error",
        title: "Maaf terdapat gangguan, silahkan coba kembali",
        text: msg,
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Mengerti",
      }).then((result) => {
        if (result.value) {
        }
      });
    },
  },
};
</script>
<style>
label {
  text-transform: uppercase;
}
#main form input[type="email"] {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset;
  color: #555555;
  display: block;
  font-size: 14px;
  height: 34px;
  line-height: 1.42857;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  width: 100%;
}
.multiselect__input {
  border: unset !important;
}
.multiselect__input:focus {
  border: 1px solid #cccccc !important;
}
</style>
